import React from 'react'
import styled from 'styled-components'

import municipio from '../../../static/assets/images/partners/municipio.png'
import comune from '../../../static/assets/images/partners/comune.jpg'
import invito from '../../../static/assets/images/partners/invito.jpg'
import ministero from '../../../static/assets/images/partners/ministero.jpg'
import regione from '../../../static/assets/images/partners/regione.jpg'
import guna from '../../../static/assets/images/partners/guna.jpg'
import claps from '../../../static/assets/images/partners/claps.png'
// import camera from '../../../static/assets/images/partners/camera.jpg'
// import xh from '../../../static/assets/images/partners/xh.jpg'
import vas from '../../../static/assets/images/partners/vas.png'
import neglia from '../../../static/assets/images/partners/neglia.jpg'
import bauadvisor from '../../../static/assets/images/partners/bauadvisor.png'
import metropolitana from '../../../static/assets/images/partners/metropolitana.jpeg'
import oralegale from '../../../static/assets/images/partners/oralegale.jpg'

import { colors, flex, media } from '../../constants/style'

import { Column, Row } from '../UI/Grid'
import Title from '../UI/Title'

const Inner = Row.extend`
  flex-wrap: wrap;
  padding: 20px 0 0;
  position: relative;
  &:after {
    background-color: ${colors.red};
    bottom: 0;
    content: '';
    height: 4px;
    left: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;
  }
  ${media.medium`
    padding: 40px 0 0;
  `} ${media.large`
    padding: 40px 40px 0;
  `};
`

const Partner = styled(Column).attrs({
  align: flex.align.CENTER,
  grow: 0,
  justify: flex.justify.CENTER,
})`
  flex-basis: 25%;
  padding: ${({ padding }) => (padding ? padding : '0 1rem')};
  margin-bottom: 40px;
  img {
    margin: 0;
    object-fit: contain;
  }
  ${media.medium`
    flex-basis: 16%
  `} ${media.large`
    flex-basis: 9%;
  `};
`

const Partners = () => (
  <Column>
    <Title>Partners</Title>
    <Inner justify={flex.justify.CENTER}>
      <Partner>
        <a
          target="_blank"
          href="https://web.comune.milano.it/wps/portal/municipi/municipio_5"
        >
          <img src={municipio} />
        </a>
      </Partner>
      <Partner padding="0">
        <a target="_blank" href="https://www.comune.milano.it/">
          <img src={comune} />
        </a>
      </Partner>
      <Partner>
        <a target="_blank" href="http://www.cittametropolitana.mi.it/">
          <img src={metropolitana} />
        </a>
      </Partner>
      <Partner>
        <a target="_blank" href="http://www.beniculturali.it/">
          <img src={ministero} />
        </a>
      </Partner>
      <Partner>
        <a target="_blank" href="https://www.invitoateatro.mi.it/">
          <img src={invito} />
        </a>
      </Partner>
      <Partner>
        <a target="_blank" href="http://claps.lombardia.it/">
          <img src={claps} />
        </a>
      </Partner>
      <Partner>
        <a target="_blank" href="https://guna.com/">
          <img src={guna} />
        </a>
      </Partner>
      <Partner padding="0 1.6rem">
        <a target="_blank" href="https://vas.it/">
          <img src={vas} />
        </a>
      </Partner>
      <Partner>
        <a target="_blank" href="https://www.bauadvisor.it/">
          <img src={bauadvisor} />
        </a>
      </Partner>
      <Partner>
        <a target="_blank" href="https://www.oralegalenews.it/">
          <img src={oralegale} />
        </a>
      </Partner>
    </Inner>
  </Column>
)

export default Partners



// WEBPACK FOOTER //
// ./src/components/Partners/index.js